<template>
    <div>
      <section id="cards">
        <article class="brewery-card" v-for="brewery in breweries" v-bind:key="brewery.breweryId"
          v-on:click="viewBreweryDetail(brewery.breweryId)">
          <div class="info">
            <h2>{{ brewery.breweryName }}</h2>
            <p><i class="fa-solid fa-location-dot blue"></i> {{ brewery.address }}</p>
            <p style="flex-grow:1;"><i class="fa-solid fa-phone blue"></i> {{ brewery.phoneNumber }}</p>
            <p><i class="fa-solid blue fa-clock"></i> {{ brewery.hours }}</p>
            <h4 v-if="this.$store.getters.getNumberOfReviewsByBreweryId(brewery.breweryId) === 0">No Ratings</h4>
            <h4 v-if="this.$store.getters.getNumberOfReviewsByBreweryId(brewery.breweryId) !== 0">
              Average Rating:
              {{ this.$store.getters.getAverageRatingForBreweryId(brewery.breweryId) }}<i class="fa-solid fa-star"></i> | {{
                this.$store.getters.getNumberOfReviewsByBreweryId(brewery.breweryId) }} Review
            </h4>
          </div>
        <img v-bind:src="brewery.imageURL" class="brewery-image" />
      </article>
      <article v-on:click="addBrewery()">
        <div class="add">
          <div class="plus">+</div>
          <div>Add A New Brewery</div>
        </div>
      </article>
    </section>
  </div>
  </template>

<script>
export default {
  name: "brewer-list",
  data() {
    return {
        userId: this.$store.getters.getUserIdByUsername
    };
  },
  methods: {
    viewBreweryDetail(breweryID) {
      this.$router.push(`/brewery/${breweryID}`)
    },
    addBrewery() {
      this.$router.push(`/breweryForm`);
    },
  },
  computed: {
    breweries() {
      return this.$store.getters.getBreweriesByUserId(this.userId);
    }
  }
};
</script>

<style>

</style>